import { render, staticRenderFns } from "./demo-select.vue?vue&type=template&id=c287dcf0&scoped=true&"
import script from "./demo-select.vue?vue&type=script&lang=ts&"
export * from "./demo-select.vue?vue&type=script&lang=ts&"
import style0 from "./demo-select.vue?vue&type=style&index=0&id=c287dcf0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c287dcf0",
  null
  
)

export default component.exports